<template>
  <div>
    <div :class="[(conEstilosClaros) ? 'form-group color-claro' : 'form-group']" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un tipo de área</option>
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} los tipos de áreas</option>
        <option v-for="(area,index) in areas" :value="area.AreaDeIntranetId" :key="index">{{area.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        areas: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      conEstilosClaros: {
          type: Boolean,
          default: false
      },
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      this.$store.dispatch("A_SICPO_Catalogos_establecer030AreasDeIntranet", parametros);
    },
    methods: {
      cargaAreasDeIntranet: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SICPO.catalogos.C030AreasDeIntranet, this.parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.areas = respuesta.data.AreasDeIntranet;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        let obtenerTipoAreaObj = this.obtenerTipoAreaObj(evento.target.value);
        this.$store.dispatch("A_SICPO_Catalogos_establecer030AreasDeIntranet", parametros);
        this.$emit("valorParaElPadre", evento,obtenerTipoAreaObj);
      },
      obtenerTipoAreaObj: function(AreaId) {
        let id = parseInt(AreaId);
        let area = this.areas.find(aBD => aBD.AreaDeIntranetId == id);
        return area;
      }
    },
    created() {
      this.cargaAreasDeIntranet();
    }
  }
</script>
<style scoped>
.color-claro select {
  background-color: rgb(185, 185, 185);
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/SICPO/Catalogos/C030AreasDeIntranet.vue